export const systemInfoQueryKeys = {
  all: ['systemInfo'] as const,
  versions: () => [...systemInfoQueryKeys.all, 'versions'] as const,
};
